export const PAYSLIP_STATUSES_ADMIN_INDEX = [
  'missing',
  'in_progress',
  'submitted',
  'validated',
  'closed',
] as const;
